module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/meditating_d29742.jpg";